var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.userType !== 'client')?_c('admin'):_vm._e(),(_vm.userType === 'client')?_c('client'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }